import {
  Route,
} from 'react-router-dom';
import React from 'react';
import TripReviewCreate from '../../pages/trip-review-create';
import TripReviewEdit from '../../pages/trip-review-edit';
import TripReviewGift from '../../pages/trip-review-gift';
import TripReviewGiftForm from '../../pages/trip-review-gift-form';
import TripReviewSubmit from '../../pages/trip-review-submitted';
import TripMatch from '../../pages/trip-match';
import TripMatchAbout from '../../pages/trip-match/about';
import TripMatchDocs from '../../pages/trip-match/docs';
import TripMatchMessages from '../../pages/trip-match/messages';

const useTripMatchesRoutes = () => (
  <>
    <Route path="trip-matches/:tripMatchId" element={<TripMatch />}>
      <Route index element={<TripMatchAbout />} handle={{ tab: '/' }} />
      <Route path="/trip-matches/:tripMatchId/messages" element={<TripMatchMessages />} handle={{ tab: '/messages' }} />
      <Route path="/trip-matches/:tripMatchId/documents" element={<TripMatchDocs />} handle={{ tab: '/documents' }} />
    </Route>
    <Route path="trip-matches/:tripMatchId/review" element={<TripReviewCreate />} />
    <Route path="trip-matches/:tripMatchId/review/:reviewId" element={<TripReviewEdit />} />
    <Route path="trip-matches/:tripMatchId/review/:reviewId/gift/" element={<TripReviewGift />} />
    <Route path="trip-matches/:tripMatchId/review/:reviewId/gift/form" element={<TripReviewGiftForm />} />
    <Route path="trip-matches/:tripMatchId/review/:reviewId/submit" element={<TripReviewSubmit />} />
  </>
);

export default useTripMatchesRoutes;
